/* KLARA by LINTEL PDP: cart drawer after any add (Kaching or native), quote/review sliders, before/after slider, sticky ATC that clicks the real ATC */
(function () {
  var form = document.querySelector('form[data-kr-add]');
  function openDrawer() { if (window.KR) window.KR.openCart(); }
  var pending = false;
  if (window.fetch) {
    var of = window.fetch;
    window.fetch = function (input) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var p = of.apply(this, arguments);
      if (/\/cart\/add(\.js)?(\?|$)/.test(url)) {
        p.then(function (r) { if (r && r.ok && !pending) { pending = true; setTimeout(function () { pending = false; openDrawer(); }, 250); } }).catch(function () {});
      }
      return p;
    };
  }
  if (form) {
    form.addEventListener('submit', function (e) {
      if (e.defaultPrevented) return;
      e.preventDefault();
      var btn = form.querySelector('[type=submit]'); btn.disabled = true;
      fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Accept': 'application/json' }, body: new FormData(form) })
        .then(function (r) { if (!r.ok) throw new Error('add'); btn.disabled = false; })
        .catch(function () { btn.disabled = false; form.submit(); });
    });
  }
  document.querySelectorAll('[data-kr-slide]').forEach(function (box) {
    var fs = box.querySelectorAll('.kr-q__track>figure'), ds = box.querySelectorAll('.kr-q__dots i'), i = 0, t;
    function show(k) { i = (k + fs.length) % fs.length; fs.forEach(function (f, n) { f.classList.toggle('is-on', n === i); }); ds.forEach(function (d, n) { d.classList.toggle('is-on', n === i); }); }
    box.querySelectorAll('[data-d]').forEach(function (b) { b.addEventListener('click', function () { clearInterval(t); show(i + parseInt(b.dataset.d, 10)); }); });
    ds.forEach(function (d, n) { d.addEventListener('click', function () { clearInterval(t); show(n); }); });
    t = setInterval(function () { show(i + 1); }, 5000);
  });
  document.querySelectorAll('[data-kr-ba]').forEach(function (ba) {
    var r = ba.querySelector('input'); r.addEventListener('input', function () { ba.style.setProperty('--p', r.value + '%'); });
  });
  var st = document.querySelector('[data-kr-sticky]'), atc = document.querySelector('[data-kr-atc]');
  if (st && atc) {
    st.querySelector('[data-kr-sticky-btn]').addEventListener('click', function () { atc.scrollIntoView({ behavior: 'smooth', block: 'center' }); setTimeout(function () { atc.click(); }, 350); });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) { es.forEach(function (e) { var on = !e.isIntersecting && e.boundingClientRect.top < 0; st.classList.toggle('is-on', on); st.setAttribute('aria-hidden', on ? 'false' : 'true'); }); }).observe(atc);
    }
  }
})();

/* ===== 10-02 (Edvin): Add to cart NEVER goes to /cart - every add (theme ATC, Kaching ATC, any /cart/add form) opens the KR brand cart drawer ===== */
(function () {
  if (window.__kr_atc) return; window.__kr_atc = 1;
  function open() { if (window.KR && window.KR.openCart) return window.KR.openCart(); if (window.__lntOpen) return window.__lntOpen(); }
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.getAttribute || !/\/cart\/add/.test(f.getAttribute('action') || '')) return;
    if (e.defaultPrevented) return;
    e.preventDefault();
    var b = f.querySelector('[type=submit]'); if (b) b.disabled = true;
    var fd = new FormData(f), tries = 0;
    (function add() {
      fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Accept': 'application/json' }, body: fd })
        .then(function (r) {
          if (r.ok) { if (b) b.disabled = false; return open(); }
          if (r.status === 422) return r.json().then(function (j) { if (b) b.disabled = false; open(); if (j && j.description) alert(j.description); });
          throw new Error('add ' + r.status);
        })
        .catch(function () { if (++tries < 2) return setTimeout(add, 800); /* 10-06: bot check (429) or network -> normal form POST, back to this page (?opencart=1), drawer opens. Never /cart, never an alert */ try { var u = new URL(location.href); u.searchParams.set('opencart', '1'); var h = document.createElement('input'); h.type = 'hidden'; h.name = 'return_to'; h.value = u.pathname + u.search; f.appendChild(h); } catch (x) {} HTMLFormElement.prototype.submit.call(f); });
    })();
  }, false);
})();

/* 10-06: back from the fallback POST (?opencart=1) -> open the brand cart drawer and clean the URL */
(function () {
  try { var u = new URL(location.href); if (u.searchParams.get('opencart') !== '1') return; u.searchParams.delete('opencart'); history.replaceState(null, '', u.pathname + u.search + u.hash); } catch (e) { return; }
  var n = 0, t = setInterval(function () { var ok = false; for (var k in window) { if (/^[A-Z]{2,4}$/.test(k) && window[k] && typeof window[k].openCart === 'function') { window[k].openCart(); ok = true; break; } } if (!ok && window.__lntOpen) { window.__lntOpen(); ok = true; } if (ok || ++n > 40) clearInterval(t); }, 150);
})();
